/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingListTransactionsSortCriteria {
    getFixupPrototypeFunction() { return MasterAccountBillingListTransactionsSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingListTransactionsSortCriteria>): MasterAccountBillingListTransactionsSortCriteria {
        let obj = Object.assign(new MasterAccountBillingListTransactionsSortCriteria(), model);
        MasterAccountBillingListTransactionsSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingListTransactionsSortCriteria>): MasterAccountBillingListTransactionsSortCriteria {
        if (!model) return null;
        return MasterAccountBillingListTransactionsSortCriteria.newInstance(<MasterAccountBillingListTransactionsSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingListTransactionsSortCriteria) {
        if (!obj) return;

        models.MasterAccountBillingListTransactionsSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingListTransactionsSortCriteria): boolean {
        Object.setPrototypeOf(obj, MasterAccountBillingListTransactionsSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.MasterAccountBillingListTransactionsSortColumn;

    ascending: boolean;

}
